<template>
  <div class="modal modal-notice" id="noticeModal">
    <div class="modal-wrap">
      <div class="sheet-panel">
        <div class="sheet-header">
          <h3>Notice</h3>
        </div>
        <div class="sheet-content">
          <h2>Please review and accept</h2>
          <p>Please review and accept the following items</p>
          <a
            href="https://traitstack.com/privacy-policy"
            target="_blank"
            class="link-container"
          >
            <h4>Privacy Policy</h4>
          </a>
          <a
            href="https://traitstack.com/terms-and-conditions"
            target="_blank"
            class="link-container"
          >
            <h4>Terms and Conditions</h4>
          </a>
          <p>
            By clicking on 'Accept' you are confirming that you have read and
            understand the Privacy Polcy and Terms and Conditions of
            Traitstack.".
          </p>
          <div class="text-center">
            <button
              type="submit"
              @click="acceptPolicies"
              class="btn btn-primary btn-loader"
              :class="{ active: loading, success: success }"
            >
              <span>Accept</span>
            </button>
            <button @click="rejectPolicies" class="btn btn-tertiary">
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import { mapState } from "vuex";

export default {
  name: "app",
  computed: {
    ...mapState(["userPrivateData"]),
    ...mapState(["acceptedPolicies"]),
    getUserPrivateData() {
      return this.userPrivateData ? this.userPrivateData : "";
    },
    getAcceptedPolicies() {
      return this.acceptedPolicies ? this.acceptedPolicies : "";
    }
  },
  data: function() {
    return {
      termsVersion: 100,
      privacyVersion: 100,
      hasAcceptedPrivacy: false,
      hasAcceptedTerms: false,
      loading: false,
      error: false,
      success: false,
      hasAcceptedPolicies: false
    };
  },
  watch: {
    getUserPrivateData(privateData) {
      if (privateData.privacy || privateData.terms) {
        if (privateData.privacy < this.privacyVersion) {
          this.hasAcceptedPrivacy = false;
        } else {
          this.hasAcceptedPrivacy = true;
        }

        if (privateData.terms < this.termsVersion) {
          this.hasAcceptedTerms = false;
        } else {
          this.hasAcceptedTerms = true;
        }
      }

      if (!this.hasAcceptedPrivacy || !this.hasAcceptedTerms) {
        if (!this.getAcceptedPolicies) {
          setTimeout(() => {
            const noticeModal = document.getElementById("noticeModal");
            noticeModal.classList.add("toggled");
          }, 250);
        }
      }
    }
  },
  methods: {
    acceptPolicies() {
      if (this.loading) {
        return false;
      }
      this.loading = true;

      let acceptPolicies = firebase.functions().httpsCallable("acceptPolicies");

      acceptPolicies()
        .then(() => {
          this.success = true;
          this.loading = false;
          setTimeout(() => {
            const noticeModal = document.getElementById("noticeModal");
            noticeModal.classList.remove("toggled");
          }, 250);
        })
        .catch(error => {
          this.success = false;
          this.loading = false;
          console.log(error);
        });
    },
    rejectPolicies() {
      const noticeModal = document.getElementById("noticeModal");
      noticeModal.classList.remove("toggled");
      this.$signOut();
    }
  }
};
</script>
